import { DropDownList } from '@syncfusion/ej2-dropdowns';

import { MtdItQuarters } from '@/shared/types/enum';
import { MtdItQuarterKind, getMtdItQuarterOptions } from '@/shared/utils/mtdItQuarter';

import { getControl } from '@/front/editable/state';
import { listen } from '@/front/event';

const QUARTER_FIELDS: { field: string; kind: MtdItQuarterKind }[] = [
  { field: 'mtdItStartOn', kind: 'start' },
  { field: 'mtdItLastMadeUpTo', kind: 'end' },
  { field: 'mtdItExitOn', kind: 'end' },
];

const refreshField = (form: HTMLFormElement, field: string, kind: MtdItQuarterKind, quartersType: MtdItQuarters) => {
  const editable = form.querySelector(`.editable[data-field="${field}"]`) as HTMLDivElement | null;
  if (!editable) return;

  const control = getControl(editable.id) as DropDownList | undefined;
  if (!control) return;

  const currentValue = (control.value as string | null) ?? null;

  control.dataSource = getMtdItQuarterOptions({ kind, quartersType, currentValue });
  control.dataBind();
  control.value = currentValue;
};

listen('editablesReady', () => {
  document.querySelectorAll('.editable[data-field="mtdItQuarters"]').forEach((element) => {
    const editable = element as HTMLDivElement;
    const form = editable.closest('form') as HTMLFormElement | null;
    if (!form) return;

    const control = getControl(editable.id) as DropDownList | undefined;
    if (!control) return;

    const refreshAll = () => {
      const quartersType = Number(control.value) as MtdItQuarters;
      for (const { field, kind } of QUARTER_FIELDS) {
        refreshField(form, field, kind, quartersType);
      }
    };

    control.addEventListener('change', refreshAll);
  });
});
